import { api } from "../../api/api";
import {
  ADD_CONTENT,
  GET_CONTENT_REQUEST,
  GET_CONTENT_SUCCESS,
  DELETE_CONTENT_REQUEST,
  CHECK_ALL_CONTENT,
  UNCHECK_ALL_CONTENT,
  CHECK_ONE_CONTENT,
  UNCHECK_ONE_CONTENT,
  DELETE_ALL_CONTENT,
  ADD_CONTENT_REQUEST,
  DELETE_CONTENT_REQUEST_SUCCESS,
  GET_CONTENT_FAILED,
  CONTENT_FLAG_OFF,
  CONTENT_SCHEDULE_DELETE,
  CONTENT_SCHEDULE_SUCCESS,
  CONTENT_UPDATED,
  CLIENT_CONTENT_SUCCESS,
  COUNT_OF_CONTENT,
  COUNT_OF_EACH_CONTENT_REQ,
  COUNT_OF_EACH_CONTENT_SUCCESS,
  GET_FOLDER_CONTENT_REQ,
  GET_FOLDER_CONTENT_SUCCESS,
  UPDATE_CONTENT_PAGE_INCREAMENT,
  UPDATE_CONTENT_PAGE_DECREAMENT,
  GET_PAGINATION_CONTENT_SUCCESS,
  GET_PAGINATION_CONTENT_REQ,
  UPDATE_PAGINATED_CONTENT_PAGE_INCREAMENT,
  UPDATE_PAGINATED_CONTENT_PAGE_DECREAMENT,
} from "../constant";

export const contentFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_FLAG_OFF,
      payload: "",
    });
  };
};
export const addContent = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: "",
    });
    const content = await api.post(`/content/upload`, obj);
    if (content.status === 201) {
      dispatch({ type: ADD_CONTENT, payload: content.data.content });
    }
  };
};

export const countOfContent = (id) => {
  return async (dispatch) => {
    const { status, data } = await api.get(`/content/countofcontent/${id}`);
    status == 200 &&
      dispatch({
        type: COUNT_OF_CONTENT,
        payload: data.contentcount,
      });
  };
};
export const countOfEachContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: COUNT_OF_EACH_CONTENT_REQ,
      payload: "",
    });
    const { status, data } = await api.get(`/content/countofeachcontent/${id}`);
    if (status == 200)
      dispatch({
        type: COUNT_OF_EACH_CONTENT_SUCCESS,
        payload: data.counts,
      });
  };
};
export const getContent = (id,page,limit) => {
  return async (dispatch) => {
    // console.log('from get content=>',id)
    dispatch({
      type: GET_CONTENT_REQUEST,
      payload: "",
    });
    const query=new URLSearchParams({
      page,
      limit
    })
    const content = await api.get(`/content/getcontent/${id}`,{params:query});
    // console.log(content)
    if (content.status === 200) {
      if (content.data.content.length > -1) {
        dispatch({
          type: GET_CONTENT_SUCCESS,
          payload: content.data.content,
        });
      } else {
        dispatch({
          type: GET_CONTENT_FAILED,
          payload: "",
        });
      }
    }
  };
};

export const increamentContentPagination=()=>{
  return async (dispatch)=>{
        dispatch({
          type:UPDATE_CONTENT_PAGE_INCREAMENT,
          payload:''
        })
  }
}
export const decreamentContentPagination=()=>{
  return async (dispatch)=>{
    dispatch({
     type:UPDATE_CONTENT_PAGE_DECREAMENT,
     payload:''
    })
  }
}

export const getFolderContent = (id,page,limit) => {
  return async (dispatch) => {
    dispatch({
      type: GET_FOLDER_CONTENT_REQ,
      payload: [],
    });
    const query=new URLSearchParams({
      page,
      limit
    })
    const content = await api.get(`/content/getfoldercontent/${id}`,{params:query});
    // console.log(content)
    if (content.status === 200) {
      if (content.data.content.length > -1) {
        dispatch({
          type: GET_FOLDER_CONTENT_SUCCESS,
          payload: content.data,
        });
      } else {
        dispatch({
          type: GET_CONTENT_FAILED,
          payload: "",
        });
      }
    }
  };
};

export const getPaginationContent = (id,page,limit) => {
  return async (dispatch) => {
    dispatch({
      type: GET_PAGINATION_CONTENT_REQ,
      payload: [],
    });
    const query=new URLSearchParams({
      page,
      limit
    })
    const content = await api.get(`/content/getfoldercontent/${id}`,{params:query});
    // console.log(content)
    if (content.status === 200) {
      if (content.data.content.length > -1) {
        dispatch({
          type: GET_PAGINATION_CONTENT_SUCCESS,
          payload: content.data,
        });
      } else {
        dispatch({
          type: GET_CONTENT_FAILED,
          payload: "",
        });
      }
    }
  };
};

export const increamentPaginatedContent=()=>{
  return async (dispatch)=>{
        dispatch({
          type:UPDATE_PAGINATED_CONTENT_PAGE_INCREAMENT,
          payload:''
        })
  }
}
export const decreamentPaginatedContent=()=>{
  return async (dispatch)=>{
    dispatch({
     type:UPDATE_PAGINATED_CONTENT_PAGE_DECREAMENT,
     payload:''
    })
  }
}

export const deleteContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_CONTENT_REQUEST,
      payload: "",
    });
    const content = await api.get(`/content/delete/${id}`);
    if (content.status === 201) {
      dispatch({
        type: DELETE_CONTENT_REQUEST_SUCCESS,
        payload: id,
      });

    }
  };
};
export const checkAllContent = () => {
  return async (dispatch) => {
    dispatch({
      type: CHECK_ALL_CONTENT,
      payload: "",
    });
  };
};
export const unCheckAllContent = () => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECK_ALL_CONTENT,
      payload: "",
    });
  };
};
export const checkOneContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHECK_ONE_CONTENT,
      payload: id,
    });
  };
};
export const unCheckOneContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECK_ONE_CONTENT,
      payload: id,
    });
  };
};
export const deleteAllContent = (updatedArr, selectedRows) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_ALL_CONTENT,
      payload: updatedArr,
    });
    await api.post(`/content/multipledelete`, { selectedRows });
  };
};
export const addContentSchedule = (id, obj) => {
  return async (dispatch) => {
    const updated = await api.patch(`/content/schedule/${id}`, obj);
    //console.log('schdule => ',updated)
    if (updated.status === 201) {
      dispatch({
        type: CONTENT_SCHEDULE_SUCCESS,
        payload: updated.data.updated,
      });
    }
  };
};
export const deleteContentSchedule = (id) => {
  return async (dispatch) => {
    // console.log('from content delete=>',id)
    const updated = await api.patch(`/content/deletecontentschedule/${id}`);
    // console.log('deleted schdule => ',updated)
    if (updated.status === 201) {
      dispatch({
        type: CONTENT_SCHEDULE_DELETE,
        payload: updated.data.updated,
      });
    }
  };
};
export const getClientContent = (id) => {
  return async (dispatch) => {
    const { status, data } = await api.get(`/content/getclientcontents/${id}`);
    if (status == 200) {
      dispatch({
        type: CLIENT_CONTENT_SUCCESS,
        payload: data.content,
      });
    }
  };
};
export const contentUpdate = (id, objForUpdateContent) => {
  return async (dispatch) => {
    const { status, data } = await api.patch(
      `/content/updatecontent/${id}`,
      objForUpdateContent
    );
    if (status === 201) {
      dispatch({
        type: CONTENT_UPDATED,
        payload: data.content,
      });
    }
  };
};
